// extracted by mini-css-extract-plugin
module.exports = {"fare":"fare-3xvBa","button":"button-AWZPc"};